/* src/app/pages/links/links.component.scss */
ul {
  padding: 0;
}
/*# sourceMappingURL=links.component.css.map */
